import { Component } from '@angular/core';
import {
  CheckNotes,
  InspectionCase,
  InspectionCaseDto,
  SubCases
} from '@authority-labs/api-interfaces';
import { Conclusion } from '@authority-labs/enums';

@Component({
  template: ''
})
export class Base1001TestResultsComponent {
  notes: string[] = [];
  cases: InspectionCaseDto[] = [];
  caseTitlesMap: Map<string, InspectionCase[]> = new Map();

  init(cases: SubCases[] = [], notes: CheckNotes[] = []): void {
    cases = cases.filter((c) => c.isApplicable);
    cases.forEach((c) => {
      this.caseTitlesMap.set(
        c.section,
        c.subCases.filter((sc) => sc.isTitle)
      );
    });

    cases.forEach((c) => {
      this.cases.push(c);
      c.subCases
        .filter(
          (sc) =>
            (sc.isApplicable &&
              this.isParentApplicable(c.section, sc.section)) ||
            this.getSectionLevel(sc.section) < 3
        )
        .forEach((sc) => this.cases.push(sc));
    });

    this.notes = notes
      .filter((note) => note.addNotesToReport && note.notes)
      .filter((note) => !note.notes.includes('undefined'))
      .map((note) => note.notes);
  }

  getConclusion(checkCase: InspectionCaseDto & { section?: string }): string {
    if (this.getSectionLevel(checkCase.section) === 1) {
      return '';
    }

    if (checkCase.isApplicable && checkCase.isTitle) {
      return '-';
    }

    if (checkCase.isApplicable) {
      return checkCase.isPassed ? Conclusion.Pass : Conclusion.Fail;
    }

    return Conclusion.NotApplicable;
  }

  isParentApplicable(parentSection: string, section: string): boolean {
    const parents = this.caseTitlesMap
      .get(parentSection)
      .filter((sc) => (section + '.').startsWith(sc.section + '.'));
    return parents.every((p) => p.isApplicable || p.section === section);
  }

  private getSectionLevel(section: string): number {
    return section.split('.').length;
  }
}
